import React, { Fragment } from 'react';

import './Loader.scss';

const Loader = () => (
  <Fragment>
    <div className="spin_loader"></div>
  </Fragment>
);

export default Loader;

// Ex: how to use
// <Loader />
